import { BasePanelController } from '../../../../../../BaseUI/BasePanelController';
import { ReserveUpdateDetailPanelComponent } from './ReserveUpdateDetailPanelComponent';
import {ReserveService} from '../../../../../../../Service/ReserveService';
import {ReservationDetailDTOInterface} from '../../../../../../../DTO/ReservationDetailDTOInterface';
import {MstClinicDTOInterface} from '../../../../../../../DTO/MstClinicDTOInterface';
import {MstDepartmentDTOInterface} from '../../../../../../../DTO/MstDepartmentDTOInterface';

export class ReserveUpdateDetailPanelController extends BasePanelController {

	// コンポーネントとコントローラーの結合用プロパティは、継承関係上の上書きする。
	// F12での参照が出来うようにする為と、クラス構造で、どのViewと紐づくか明示する為。
	public combineView: ReserveUpdateDetailPanelComponent;


	public async getInitialData(param: { view: any; reservationId: number }): Promise<{
		reservation: ReservationDetailDTOInterface;
		selectedClinicId: number;
		clinicList: Array<MstClinicDTOInterface>;
		departmentVisitList: Array<MstDepartmentDTOInterface>;
		departmentOnlineList: Array<MstDepartmentDTOInterface>;
		visitTypeList: Array<{id: number; name: string}>;
		appointmentTypeList: Array<{id: number; name: string}>;
	}> {

		const svc = new ReserveService(param.view);
		const res = await svc.getUpdateViewData({reservationId: param.reservationId});

		return res;

	}
}
